<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="categorieForm" method="POST" enctype="multipart/form-data">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="categories">Category :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <select class="form-control show-tick" id="categoryData" v-model="categoryIdSearch">
                                        <option value="">Please select</option>
                                        <template v-for="(categoryData , index) in categoryArr">
                                            <option :value="categoryData.value">{{categoryData.text}}</option>
                                        </template>
                                    </select>
                                </div>
                            </div>-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="categories">Category :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="categoryId"
                                              @change="changedValue"
                                              @input="changedCategoryFor()"
                                              name="categoryId"
                                              id="categoryId"
                                              label="text"
                                              :filterable="false"
                                              :options="categoryArr"
                                              @search="onSearchCategory"
                                              placeholder="Select Parent Category">
                                        <template slot="no-options">
                                            Search Category...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{categoryIdErrors}}</font>
                                </div>
                            </div>
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="mediaSource">Media Source :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                     <input type="text" id="mediaSource" name="mediaSource" class="form-control"
                                               placeholder="Enter Media Source" v-model="mediaSource">
                                </div>
                            </div>-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="mediaSource">Media Source :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input maxlength="190" type="text" id="mediaSource" name="mediaSource" class="form-control"
                                           placeholder="Enter Media Source" v-model="mediaSource">
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="mediaCaption">Media Caption :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input maxlength="190" type="text" id="mediaCaption" name="mediaCaption" class="form-control"
                                           placeholder="Enter Media Caption" v-model="mediaCaption">
                                </div>
                            </div>
                            <template v-if="slug == 'video'">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <span id="myForm">
                                        <label><input id="uploadManually" type="radio" name="cars" value="1" v-model="picked" checked="checked"/>Enter Manually</label>
                                        <label><input id="vodepUrl" type="radio" name="cars" value="2" v-model="picked">Enter Video URL</label>
                                    </span>
                                </div>
                            </template>

                            <div class="col-12 forms-block" v-if="!isHideDropZone">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="mediaCaption">Media File :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        @vdropzone-mounted="fileAdd"
                                        @vdropzone-file-added="fileAdd"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{cropError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block" v-else>
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="mediaURL">Video URL :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input maxlength="190" type="text" id="mediaURL" name="mediaURL" class="form-control"
                                           placeholder="Video URL" v-model="mediaURL">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{mediaURLError}}</font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="saveMediaDetail()"></input>
                                    <button class="btn btn-primary" v-on:click.prevent="removeAllFiles()">Remove File</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import axios from 'axios';
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';

    var self;
    export default {
        mixins: [SessioMixin],
        components: {
            vueDropzone: vue2Dropzone,
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                pageTitle: '',
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    // acceptedFiles: ".jpg, .jpeg, .png, .mov, .mp4, .mkv",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

//                categoryData: '',
//                categoryArr: [],
                categoryId: '',
                categoryIdErrors: '',
                cropError: '',
                categoryArr: [],
                mediaSource: "",
                mediaCaption: "",
                categoryIdSearch: "",
                imagesType: [],
                imagesSize: [],
                imagesPaths: [],
                mediaThumbnailPaths: [],
                isFileUploaded: false,
                mediaURL: '',
                mediaURLError: '',
                slug: '',
                picked: 1,
                isHideDropZone: false,
                fileUploaded: true,
            }
        },

        beforeMount: function () {
            self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3] == 'video') {
                self.dropzoneOptions.acceptedFiles = ".mp4";
            } else {
                self.dropzoneOptions.acceptedFiles = ".jpg, .jpeg, .png";
            }
            self.checkLogin();
        },
        watch: {
            picked: function (picked) {
                self.isHideDropZone = false;
                if (picked == 2) {
                    self.isHideDropZone = true;
                }
            }
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            self.slug = '';
            self.pageTitle = 'Add Media';
            if (segments[3] == 'video') {
                self.pageTitle = 'Add Video';
                self.slug = 'video';
                // self.isHideDropZone = false;
                this.$refs.dropzone.setOption('acceptedFiles', ".mp4");
            }

            if (segments[3] == 'image') {
                self.pageTitle = 'Add Image';
                self.slug = 'image';
                // self.isHideDropZone = false;
                this.$refs.dropzone.setOption('acceptedFiles', ".jpg, .jpeg, .png");
            }
            self.showLoader();
            self.MenuClose();
            self.loadCategory();
            self.loadCategoryFirst();
            $("#categoryId").on('keyup', function () {
                self.categoryIdErrors = '';
            });
            $("#alertError").hide();
            self.$nextTick(function () {
                self.hideLoader();
            });
        },

        methods: {
            buttonBack() {
                if (self.slug == 'image') {
                    self.$router.push('/backend/listmedia');
                } else {
                    self.$router.push('/backend/listvideos');
                }
            },
            fileAdd: function (file, xhr, error) {
                if (this.$refs.dropzone.dropzone.options.acceptedFiles) {
                    if (self.slug == 'image') {
                        this.$refs.dropzone.setOption('acceptedFiles', ".jpg, .jpeg, .png");
                    } else {
                        this.$refs.dropzone.setOption('acceptedFiles', ".mp4");
                    }
                }
                /* console.log("File Add"); */
            },
            promptMessage: function (messagge, type) {
                if (typeof type === "undefined" || type === null) {
                    type = "success";
                }
                var AddClass = (type == "success") ? "alert-success" : "alert-danger";
                var RemoveClass = (type == "success") ? "alert-danger" : "alert-success";
                $("#alertError").show();
                $("#alertError").removeClass(RemoveClass);
                $("#alertError").addClass(AddClass);
                $("." + AddClass).removeClass("hide");
                $("." + AddClass).addClass("show");
                $("#errorMsg").html(messagge);
                setTimeout(function () {
                    $("." + AddClass).removeClass("show");
                    $("." + AddClass).addClass("hide");
                }, 5000);
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
            },
            removedSelectedFile(file, xhr, error) {
                if (self.imagesPaths.length <= 0) {
                    self.isFileUploaded = false;
                }
                var filePath = JSON.parse(file.xhr.response);
                //console.log(file);
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === filePath.content.media_path) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        self.mediaThumbnailPaths.splice(i, 1);
                        // break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }
            },

            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'gallery',
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'gallery',
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfilesAdded: function (file) {
                /*console.log(file);*/
                for (var i = 0; i < file.length; i++) {
                    var indiFile = file[i];
                    var fileSize = indiFile.size / (1024 * 1024);
                    /*console.log(fileSize);*/
                    //return;
                    if (indiFile.type == 'image/jpeg' || indiFile.type == 'image/jpg' || indiFile.type == 'image/png') {
                        if (fileSize > 0.1) { // Allowing image upto 4 MB to be uploaded
                            alert("Please select media upto 4 MB of size.");
                            self.$refs.dropzone.removeFile(indiFile);
                        }
                    }
                }
            },
            vfileSuccess: function (file, response) {
                self.isFileUploaded = true;
                self.imagesPaths.push(response.content.media_path);
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths.push(response.content.media_thumb_path);
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                if (self.imagesPaths.length > 0) {
                    self.cropError = "";
                } else {
                    self.cropError = 'Please Upload Media 1223232';
                }
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            saveMediaDetail: function () {
                if (self.checkForm()) {
                    if (self.picked == 1) {
                        if (self.imagesPaths.length > 0) {
                            var fields = {
                                categoryId: self.categoryId.value,
                                mediaSource: self.mediaSource,
                                mediaCaption: self.mediaCaption,
                                mediaPath: self.imagesPaths,
                                mediaThumbnailPaths: self.mediaThumbnailPaths,
                                mediaType: self.imagesType,
                                mediaSize: self.imagesSize,
                                slug: self.slug,
                                picked: self.picked
                            };
                            var config = {
                                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                            };
                            self.showLoader();
                            HTTP.post("addmedia", fields, config)
                                    .then(function (response) {
                                        self.removeAllFiles();
                                        self.categoryId = '';
                                        self.mediaSource = '';
                                        self.mediaCaption = '';
                                        self.imagesPaths = [];
                                        self.mediaThumbnailPaths = [];
                                        self.imagesType = [];
                                        self.imagesSize = [];
                                        self.picked = 1;
                                        self.mediaURL = '';
                                        self.promptMessage(response.data.message, 'success');
                                        self.hideLoader();
                                    })
                                    .catch(function (err) {
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                //EventBus.$emit("logged-in", true, "", "");
                                            }
                                            self.error = err.response.data.message;
                                        }
                                        self.hideLoader();
                                    });
                        } else {
                            self.cropError = 'Please Upload Media 54353';
                        }
                    } else {
                        var fields = {
                            categoryId: self.categoryId.value,
                            mediaURL: self.mediaURL,
                            slug: self.slug,
                            picked: self.picked
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                        };
                        self.showLoader();
                        HTTP.post("addmedia", fields, config)
                                .then(function (response) {
                                    // self.removeAllFiles();
                                    self.categoryId = '';
                                    self.mediaSource = '';
                                    self.mediaCaption = '';
                                    self.imagesPaths = [];
                                    self.mediaThumbnailPaths = [];
                                    self.imagesType = [];
                                    self.imagesSize = [];
                                    self.picked = 1;
                                    self.mediaURL = '';
                                    self.promptMessage(response.data.message, 'success');
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    alert(err);
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                    self.hideLoader();
                                });
                    }
                }

            },
            checkForm: function () {
                var checked = true;
                self.cropError = "";
                
                if (self.picked == 1) {
                    if (self.isFileUploaded == false) {
                        self.cropError = 'Please Upload Media 76775';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.categoryId) {
                    self.categoryIdErrors = "Category is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.picked == 1) {
                    if (self.imagesPaths.length > 0) {
                        self.cropError = "";
                    } else {
                        self.cropError = 'Please Upload Media';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.picked == 2) {
                    if (!self.mediaURL || self.mediaURL == '' || self.mediaURL == null) {
                        self.mediaURLError = "Media URL is Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.fileUploaded == false) {
                    self.cropError = "Please Wait While Document Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.mediaURLError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            changedCategoryFor: function () {
                self.categoryIdErrors = '';
            },
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/backend/gallery/AddMedia.vue